import React from 'react';
import { toast } from '../../../ui/feedback';

// A ticket number copies itself on a click and says so (owner, 16 Oct 2026: "لما ادوس على رقم التيكت تتنسخ ويقولي انها
// اتنسخت") - the Fines list and the fine window. The rest of a list row still opens the fine.

/** The text on the clipboard: the browser's clipboard, else the old copy (a page without clipboard access). */
const copyText = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch (e) { /* not allowed here: the old way below */ }
    try {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        const ok = !!document.execCommand?.('copy');
        document.body.removeChild(ta);
        return ok;
    } catch (e) {
        return false;
    }
};

export const copyTicket = async (ticket) => {
    const t = String(ticket ?? '').trim();
    if (!t) return;
    if (await copyText(t)) toast.success(`Ticket ${t} copied`);
    else toast.error(`Could not copy ${t} - select it and press Ctrl+C`);
};

export default function TicketCopy({ ticket }) {
    return (
        <button type="button" className="ds-cell-id cursor-copy hover:underline underline-offset-2" title="Copy the ticket number"
                aria-label={`Copy ticket ${ticket}`} onClick={(e) => { e.stopPropagation(); copyTicket(ticket); }}>
            {ticket}
        </button>
    );
}
